module.exports = __webpack_public_path__ + "img/tzys.2a881663.png";